<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="coach_id">
          <el-select
            v-model="listQuery.coach_id"
            filterable
            remote
            reserve-keyword
            placeholder="请选择教练"
            :remote-method="getCoachList"
            clearable
            @visible-change="setCoachList"
            @change="SearchData"
            @keyup.enter.native="SearchData"
          >
            <el-option v-for="item in coachList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="title">
          <el-input v-model="listQuery.title" placeholder="请输入套餐名称" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="type">
          <el-select v-model="listQuery.type" placeholder="请选择课程类型" clearable @change="SearchData">
            <el-option v-for="item in dictionary['kclx']" :key="item.value" :label="item.label" :value="item.value" @click.native="listQuery.type = item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="teach_hour">
          <el-input v-model="listQuery.teach_hour" placeholder="请输入总课时" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="listQuery.status" placeholder="请选择上架状态" clearable @change="SearchData" @keyup.enter.native="SearchData">
            <el-option label="上架" :value="0"></el-option>
            <el-option label="下架" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="examine">
          <el-select v-model="listQuery.examine" placeholder="请选择审核状态" clearable @change="SearchData" @keyup.enter.native="SearchData">
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="未通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'CoachCombo.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'CoachCombo.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column align="center" prop="coach_name" label="教练 "> </el-table-column>
      <el-table-column align="center" prop="title" label="套餐名称 "> </el-table-column>
      <el-table-column align="center" prop="image" label="缩略图 ">
        <template slot-scope="scope">
          <img :src="scope.row.image" style="width: 55px;height:35px;">
        </template>
      </el-table-column>
      <el-table-column align="center" prop="price" label="价格 ">
        <template slot-scope="scope">
          ￥{{ scope.row.price || 0 }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="teach_hour" label="总课时 ">
        <template slot-scope="scope">
          {{ scope.row.teach_hour || 0 }}节课
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="课程状态 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" type="success">上架</el-tag>
          <el-tag v-else type="danger">下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="is_hot" label="是否推荐 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_hot == 1" type="success">推荐</el-tag>
          <el-tag v-else type="danger">不推荐</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="examine" label="审核状态 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.examine==0" type="info">待审核</el-tag>
          <el-tag v-if="scope.row.examine==1" type="success">已通过</el-tag>
          <el-tag v-if="scope.row.examine==2" type="danger">未通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="400" class-name="action">
        <template slot-scope="scopes">
          <el-button v-if="scopes.row.status == 1" v-auth="'CoachCombo.update'" plain type="success" icon="el-icon-upload2" size="mini" @click="HandleStatus(scopes.row)">上架</el-button>
          <el-button v-if="scopes.row.status == 0" v-auth="'CoachCombo.update'" plain type="danger" icon="el-icon-download" size="mini" @click="HandleStatus(scopes.row)">下架</el-button>
          <el-button v-if="scopes.row.examine == 0" v-auth="'CoachCombo.examine'" plain icon="el-icon-set-up" type="warning" size="mini" @click="HandleAudit(scopes.row)">审核</el-button>
          <el-button v-auth="'CoachCombo.update'" plain type="primary" icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'CoachCombo.delete'" plain type="danger" icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增课程':'编辑课程'" :visible.sync="dialogFormVisible" top="6vh" width="70%">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="110px" style="width: 100%;height:65vh;overflow-y: scroll;">
        <el-form-item label="教练" prop="coach_id">
          <el-select
            v-model="temp.coach_id"
            filterable
            remote
            reserve-keyword
            placeholder="请选择教练"
            :remote-method="getCoachList"
            style="width:300px;"
            clearable
            @visible-change="setCoachList"
          >
            <el-option v-for="item in coachList" :key="item.id" :label="item.name" :value="item.id" @click.native="temp.coach_name = item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐名称" prop="title">
          <el-input v-model="temp.title" placeholder="请输入套餐名称" style="width:90%;" clearable maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="课程类型" prop="type_id">
          <el-select v-model="temp.type_id" placeholder="请选择课程类型" style="width:300px;">
            <el-option v-for="item in dictionary['kclx']" :key="item.value" :label="item.label" :value="item.value" @click.native="temp.type = item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教学人数" prop="teach_number_id">
          <el-select v-model="temp.teach_number_id" placeholder="请选择教学人数" style="width:300px;">
            <el-option v-for="item in dictionary['jxrs']" :key="item.value" :label="item.label" :value="item.value" @click.native="temp.teach_number = item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程简介" prop="desc">
          <el-input v-model="temp.desc" placeholder="请输入课程简介" type="textarea" rows="6" style="width:90%;" clearable maxlength="255" show-word-limit />
        </el-form-item>
        <el-form-item label="列表图片" prop="image">
          <FileList v-model="temp.image" :item-width="110" :item-height="70" :limit="1" type="image" />
          <span>建议尺寸：高70/宽110</span>
        </el-form-item>
        <el-form-item label="轮播图片" prop="banner">
          <FileList v-model="temp.banner" :item-width="187.5" :item-height="100" :limit="9" type="image" />
          <span>最多上传9张展示图,建议尺寸：高200/宽375</span>
        </el-form-item>
        <el-form-item label="套餐价格" prop="price">
          <el-input-number v-model="temp.price" :min="0" :step="1" :precision="0" placeholder="请输入价格" />
        </el-form-item>
        <el-form-item label="总课时" prop="teach_hour">
          <el-input v-model.number="temp.teach_hour" style="width:300px;" placeholder="请输入总课时" @input="temp.teach_hour = Number(temp.teach_hour)?Number(temp.teach_hour):0" @change="temp.teach_hour = Number(temp.teach_hour)?Number(temp.teach_hour):0">
            <span slot="suffix">节课</span>
          </el-input>
        </el-form-item>
        <el-form-item label="是否推荐" prop="is_hot">
          <el-switch v-model="temp.is_hot" active-color="#13ce66" active-text="推荐" active-value="1" inactive-value="0" inactive-text="不推荐"></el-switch>
          <p class="tishi">推荐可在小程序首页进行展示（结合排序编号越小越靠前）</p>
        </el-form-item>
        <el-form-item label="排序" prop="order_no">
          <span slot="label">
            排序
            <el-tooltip content="排序越小，小程序展示越靠前" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input-number v-model="temp.order_no" :min="1" :max="99999" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="temp.status" style="width:300px">
            <el-radio :label="0">上架</el-radio>
            <el-radio :label="1">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课程详情" prop="content">
          <WangEditor v-model="temp.content" :value.sync="temp.content" placeholder="请输入课程详情" style="width:90%;" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
    <!--弹窗审核窗体-->
    <el-dialog title="课程审核" :visible.sync="dialogAuditVisible">
      <el-form v-if="dialogAuditVisible" ref="auditForm" :rules="rulesAudit" :model="auditTemp" label-width="110px">
        <el-form-item label="审核状态" prop="examine">
          <el-radio-group v-model="auditTemp.examine">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="auditTemp.examine == 2" label="不通过原因" prop="examine_message">
          <el-input v-model="auditTemp.examine_message" type="textarea" rows="5" placeholder="请输入不通过原因" maxlength="255" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAuditVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmAuditData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/coach/combo' // 和数据交互相关写在api 方便复用
import coachapi from '@/api/coach/coach' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import WangEditor from '@/components/WangEditor'
import FileList from '@/components/attachment/FileList'
import dict_data from '@/api/system/dict_data'

export default {
  name: 'CoachCombo',
  components: { Pagination, WangEditor, FileList },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    var validateAuditReasonPass = (rule, value, callback) => {
      if (this.auditTemp.examine === 2 && !value) {
        callback(new Error('请输入不通过原因'))
      } else {
        callback()
      }
    }
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        coach_id: [{ required: true, message: '请选择教练', trigger: ['blur', 'change'] }],
        title: [{ required: true, message: '请输入套餐名称', trigger: ['blur', 'change'] }],
        desc: [{ required: true, message: '请输入简介', trigger: ['blur', 'change'] }],
        image: [{ required: true, message: '请上传缩略图', trigger: ['blur', 'change'] }],
        banner: [{ required: true, message: '请上传轮播图', trigger: ['blur', 'change'] }],
        price: [{ required: true, message: '请输入价格', trigger: ['blur', 'change'] }],
        type_id: [{ required: true, message: '请选择课程类型', trigger: ['blur', 'change'] }],
        teach_number_id: [{ required: true, message: '请选择教学人数', trigger: ['blur', 'change'] }],
        teach_hour: [{ required: true, message: '请输入总课时', trigger: ['blur', 'change'] }],
        content: [{ required: true, message: '请输入课程详情', trigger: ['blur', 'change'] }]
      },
      rulesAudit: {
        examine: [{ required: true, message: '请选择审核状态', trigger: ['blur', 'change'] }],
        examine_message: [{ validator: validateAuditReasonPass, trigger: 'blur' }]
      },
      auditTemp: {},
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      dialogAuditVisible: false,
      coachList: [],
      // 字典参数
      dictionary: []
      // 字典参数

    }
  },
  created() {
    this.getCoachList('')
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: 'kclx,jxrs,' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    getCoachList(str) {
      coachapi.Query({ page: 1, limit: 10, name: str, isPaginator: false, order: 'asc', sort: 'order_no' }).then(response => {
        this.coachList = response.data
      })
    },
    setCoachList(bool) {
      bool ? '' : this.getCoachList('')
    },
    HandleStatus(row) {
      this.$confirm('您确定要' + (row.status ? '上架' : '下架') + '的操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.ChangeStatus({ field: 'status', value: 1 - row.status, id: row.id }).then(response => {
          this.$message({
            type: 'success',
            message: (row.status ? '上架' : '下架') + '成功!'
          })
          this.loadData()
        })
      })
    },
    // 审核弹窗
    HandleAudit(row) {
      this.auditTemp = {
        id: row.id
      }
      this.dialogAuditVisible = true
    },
    // 提交审核
    ConfirmAuditData() {
      this.$refs['auditForm'].validate(valid => {
        api.Audit(this.auditTemp).then(res => {
          this.$notify({
            title: '成功',
            message: '审核成功',
            type: 'success',
            duration: 2000
          })
          this.loadData()
          this.dialogAuditVisible = false
        })
      })
    },
    // 显示添加窗体
    HandleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.dialogFormVisible = true
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.temp = JSON.parse(JSON.stringify(row)) // copy obj
      this.dialogStatus = 'update'
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.dialogFormVisible = true
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        coach_id: '',
        title: '',
        desc: '',
        price: 0,
        teach_hour: 1,
        content: '',
        status: 0,
        is_hot: 0
      }
    }

  }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 5px;  /* 定义滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ecf5ff; /* 定义轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b3d8ff; /* 定义滑块的背景颜色 */
}
::-webkit-scrollbar-thumb:hover {
    background: #b3d8ff; /* 定义滑块在悬停状态下的背景颜色 */
}
</style>
